module.exports = __webpack_public_path__ + "static/media/LegacyIcon-Yellow.a4ed44a0.png";